var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokeballCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_58148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.98 9C94.5302 9 9 94.5212 9 200C9 305.479 94.5302 391 199.98 391C305.43 391 391 305.479 391 200C391 94.5212 305.47 9 199.98 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.979 0C89.5604 0 0 89.5604 0 200.021C0 310.482 89.5604 400.042 199.979 400.042C310.398 400.042 400 310.482 400 200.021C400 89.5604 310.44 0 199.979 0ZM259.448 200.021C259.448 232.798 232.798 259.448 200.021 259.448C184.115 259.448 169.216 253.237 158.095 242.031C146.847 230.868 140.804 215.885 140.804 200.021C140.804 184.157 146.847 169.258 158.095 158.011C169.216 146.805 184.115 140.636 200.021 140.636C215.927 140.636 230.784 146.763 242.031 158.011C253.279 169.258 259.448 184.157 259.448 200.021ZM199.979 382.373C151.296 382.373 105.55 363.404 71.0524 328.99C39.9119 297.765 21.5297 257.224 18.2562 213.661H114.406C117.218 231.623 125.695 248.201 138.705 261.253C155.157 277.662 176.938 286.686 200.021 286.686C223.104 286.686 244.927 277.704 261.337 261.253C274.431 248.159 282.866 231.623 285.678 213.661H381.702C374.777 307.796 296.003 382.373 200.021 382.373H199.979Z",
    fill: "#0E141B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.979 234.729C219.117 234.729 234.729 219.201 234.729 200.021C234.729 180.841 219.117 165.313 199.979 165.313C180.842 165.313 165.271 180.841 165.271 200.021C165.271 219.201 180.842 234.729 199.979 234.729Z",
    fill: "#0E141B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.979 226.797C214.752 226.797 226.755 214.836 226.755 200.021C226.755 185.206 214.71 173.245 199.979 173.245C185.248 173.245 173.203 185.206 173.203 200.021C173.203 214.836 185.206 226.797 199.979 226.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.052 71.0524C105.55 36.5964 151.295 17.6267 199.979 17.6267C248.662 17.6267 294.491 36.5964 328.947 71.0524C360.214 102.277 378.512 142.776 381.66 186.381H285.636C282.824 168.419 274.388 151.799 261.294 138.705C244.885 122.38 223.103 113.314 199.979 113.314C156.835 113.314 120.994 145.001 114.363 186.381H18.2559C21.5294 142.776 39.9115 102.235 71.052 71.0524Z",
    fill: "#E60013"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_58148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeballCursor);
export default __webpack_public_path__ + "static/media/pokeball-cursor.7ce84a638861a77b245ee9eb280ea020.svg";
export { ForwardRef as ReactComponent };